<dialog
  #dialog
  class="bg-medium-yellow fixed left-1/2 top-1/2 mx-4 max-h-[80vh] w-4/5 max-w-3xl -translate-x-1/2 -translate-y-1/2 transform rounded-3xl p-6 md:mx-0"
  (click)="onBackdropClick($event)"
>
  <div class="relative flex flex-col items-center justify-center gap-4">
    <!-- Header con título y botón de cierre -->
    <div class="flex w-full items-center justify-between">
      <h2 class="my-3 self-start px-6 text-3xl font-bold text-field-green">{{ title }}</h2>
      <div class="sticky right-3 top-0 z-10 flex justify-end">
        <button
          (click)="onCancel()"
          class="btn flex items-center justify-center rounded-xl border-2 border-medium-green bg-medium-green px-2 py-2 text-lg text-seasalt transition delay-100 ease-in hover:border-field-green hover:bg-seasalt hover:text-dark-blue"
          [disabled]="loading"
        >
          <mat-icon fontIcon="close"></mat-icon>
        </button>
      </div>
    </div>

    <!-- Contenido del mensaje -->
    <div
      class="mb-4 flex w-full flex-col items-center justify-center gap-4 rounded-3xl bg-dark-blue py-6 font-semibold text-seasalt"
    >
      <p class="m-4 text-center">{{ message }}</p>
      <p *ngIf="!message.includes('?')">¿Desea proseguir con la operación?</p>
    </div>

    <!-- Botones de acción -->
    <div class="flex gap-4">
      <!-- Botón Cancelar -->
      <app-loading-button
        *ngIf="hasCancelButton"
        [text]="cancelButtonText"
        [icon]="cancelButtonIcon"
        [deleteButton]="true"
        [loading]="loading"
        (clicked)="onCancel()"
      />
      <!-- Botón Confirmar -->
      <app-loading-button
        [text]="confirmButtonText"
        [icon]="confirmButtonIcon"
        [deleteButton]="isDeleteAction"
        [loading]="loading"
        (clicked)="onConfirm()"
      />
    </div>
  </div>
</dialog>
